module.exports = ["Copernicus","Sentinel-1","Sentinel-2"]